/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Reference_EntryInputs */

const en_reading_class_reference_entry = /** @type {(inputs: Reading_Class_Reference_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliography`)
};

const es_reading_class_reference_entry = /** @type {(inputs: Reading_Class_Reference_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliografía`)
};

/**
* | output |
* | --- |
* | "Bibliography" |
*
* @param {Reading_Class_Reference_EntryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_reference_entry = /** @type {((inputs?: Reading_Class_Reference_EntryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Reference_EntryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_reference_entry(inputs)
	return en_reading_class_reference_entry(inputs)
});